export default __webpack_public_path__ + "static/media/Icon-pencil.ca73e9ac.svg";